import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
interface FooterLink {
  label: string;
  href: string;
}
const LEGAL_LINKS: FooterLink[] = [{
  label: 'Términos y condiciones',
  href: '#faq'
}, {
  label: 'Política de privacidad',
  href: '#faq'
}, {
  label: 'Preguntas frecuentes',
  href: '#faq'
}];
export function Footer() {
  return <footer id="site-footer" className="border-t border-graphite-line bg-ink text-white" data-id="element-73" data-mp="36nd1p6jrvpxv">
      <div className="mx-auto max-w-5xl px-5 py-10 sm:py-12" data-id="element-74" data-mp="3ucxoy1myl9cy">
        <div className="flex flex-col gap-7 sm:flex-row sm:items-start sm:justify-between" data-id="element-75" data-mp="37o7wzgy05fh">
          <div data-id="element-76" data-mp="3lf5bl30ssbs7">
            <p className="font-display text-[1.25rem] font-extrabold uppercase leading-tight tracking-tight sm:text-[1.45rem]" data-id="element-77" data-mp="3ldkeb5n3meqn">
              100 Scripts de <span className="mark-green" data-id="element-78" data-mp="29z6tyark0hfd">WhatsApp</span>
            </p>
            <p className="mt-2 font-sans text-[0.8rem] text-white/50" data-id="element-79" data-mp="29xvrce9uhfpu">
              Un producto de{' '}
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="font-bold text-wa transition-colors duration-200 ease-out hover:text-white focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-wa" data-id="element-80" data-mp="2ew6z8jgkxg5f">
                Creativo Digital™
              </a>
            </p>
          </div>

          <ul className="space-y-2 text-[0.82rem]" data-id="element-81" data-mp="82qsbsqetttq">
            <li data-id="element-82" data-mp="81fqhygiyw59">
              <a href="mailto:soporte@creativodigital.shop" className="inline-flex items-center gap-2.5 font-medium text-white/60 transition-colors duration-200 ease-out hover:text-wa focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-wa" data-id="element-83" data-mp="80xk4905f1jm">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-graphite" data-id="element-84" data-mp="qthyklf3p43w">
                  <MailIcon className="h-4 w-4 text-wa" aria-hidden strokeWidth={2.5} data-id="element-85" data-mp="ms6h536drp6s" />
                </span>
                soporte@creativodigital.shop
              </a>
            </li>
            <li data-id="element-86" data-mp="yu7ictvibtz9">
              <a href="https://instagram.com/creativodigitalstudio" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-white/60 transition-colors duration-200 ease-out hover:text-wa focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-wa" data-id="element-87" data-mp="ytoak5zkmlyy">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-graphite" data-id="element-88" data-mp="1hk5zdzha8xf1">
                  <InstagramIcon className="h-4 w-4 text-wa" aria-hidden strokeWidth={2.5} data-id="element-89" data-mp="1mjikaeolfuez" />
                </span>
                @creativodigitalstudio
              </a>
            </li>
            <li data-id="element-90" data-mp="3obomle3mrfgi">
              <a href="https://www.creativodigital.shop" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2.5 font-medium text-white/60 transition-colors duration-200 ease-out hover:text-wa focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-wa" data-id="element-91" data-mp="3obwwqy8dc6o0">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-graphite" data-id="element-92" data-mp="21ma8fecpzdyw">
                  <GlobeIcon className="h-4 w-4 text-wa" aria-hidden strokeWidth={2.5} data-id="element-93" data-mp="1woi7juu3khik" />
                </span>
                www.creativodigital.shop
              </a>
            </li>
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-graphite-line pt-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-94" data-mp="2pdflxmv6tu61">
          <ul className="flex flex-wrap gap-x-4 gap-y-1.5 font-sans text-[0.74rem] text-white/40" data-id="element-95" data-mp="2kfe4t7hbo4x7">
            {LEGAL_LINKS.map(link => <li key={link.label} data-id="element-96" data-mp="18ynxtm52r92j">
                <a href={link.href} className="transition-colors duration-200 ease-out hover:text-wa focus:outline-none focus-visible:rounded-md focus-visible:ring-2 focus-visible:ring-wa" data-id="element-97" data-mp="18zpi8h7zd7wx">
                  {link.label}
                </a>
              </li>)}
          </ul>
          <p className="font-sans text-[0.74rem] text-white/40" data-id="element-98" data-mp="2iv1i6u4j9wal">
            © Creativo Digital™ 2026 — Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}